// extracted by mini-css-extract-plugin
export default {"customModalStyle":"AppContainer__customModalStyle___zadDE"};